import { render, staticRenderFns } from "./EditorInstall.vue?vue&type=template&id=153d274a"
import script from "./EditorInstall.vue?vue&type=script&lang=js"
export * from "./EditorInstall.vue?vue&type=script&lang=js"
import style0 from "./EditorInstall.vue?vue&type=style&index=0&id=153d274a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_df42b2ab6613268ca01723f0a843be52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports